<template>
  <app-popup :active.sync="active" title="Проверка количества приборов"
             class="house-importer-check-amount-devices-popup" width="510px">

    <div v-if="status === STATUSES.loading" class="house-importer-check-amount-devices-popup__loading">
      <div class="block-loading"/>
      <div>Получаю данные...</div>
    </div>
    <div v-else-if="status === STATUSES.error" class="house-importer-check-amount-devices-popup__error">
      <div class="house-importer-check-amount-devices-popup__error-icon">
        <app-icon name="XIcon" size="60px"/>
      </div>
      <div class="house-importer-check-amount-devices-popup__error-text">
        Данные не получены

        <div class="house-importer-check-amount-devices-popup__error-sub-text">
          {{errorText}}
        </div>
      </div>
    </div>
    <div v-else-if="status === STATUSES.loaded">
      <div v-if="accounts.length">
        <vs-table :data="accounts" hoverFlat class="house-importer-check-amount-devices-popup__table" no-data-text="Данных нет">
          <template slot="thead">
            <vs-th>Аккаунты ({{accounts.length}})</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="`${trIndex}`" v-for="(tr, trIndex) in data">
              <vs-td>{{tr}}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div v-else class="house-importer-check-amount-devices-popup__done">
        <div class="house-importer-check-amount-devices-popup__done-icon">
          <app-icon name="CheckIcon" size="120px"/>
        </div>
        <div class="house-importer-check-amount-devices-popup__done-text">
          Аккаунтов с несопадающим количество приборов не найдено
        </div>
      </div>
    </div>
  </app-popup>
</template>

<script>
  const STATUSES = {
    loading: 0,
    loaded: 1,
    error: 2
  };

  export default {
    name: "CheckAmountDevicesPopup",
    props: {
      importInfo: {}
    },
    data() {
      return {
        active: false,
        STATUSES: STATUSES,
        status: STATUSES.loading,
        errorText: "",
        accounts: []
      }
    },
    methods: {
      open() {
        this.active = true;
        this.getData();
      },
      async getData(){
        this.status = STATUSES.loading;

        try{
         let {data} = await this.$http.get('import/houses/devices_qty_match', {
           params: {
             import_id: this.importInfo.id
           }
         });

         this.accounts = data;

         setTimeout(() => {
           this.status = STATUSES.loaded;
         }, 300);

        }
        catch(e){
          this.status = STATUSES.error;
          this.errorText = e.message;
        }
      }
    }
  }
</script>

<style lang="scss">

  .house-importer-check-amount-devices-popup {

    &__loading {
      padding: 20px 0;

      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .block-loading {
        width: 60px;
        height: 60px;
        flex: 0;
        margin-bottom: 15px;
      }
    }

    &__error {
      padding: 20px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      color: rgba(var(--app-danger), 1);

      &-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
      }

      &-text {
        font-size: 14px;
        font-weight: 500;
        text-align: center;
      }

      &-sub-text {
        font-size: 16px;
        display: flex;
        align-items: center;
        line-height: 1.1;

        &-icon {
          margin-left: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: -2px;
        }

      }
    }

    &__done{
      padding: 20px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      color: rgba(var(--app-success), 1);

      &-icon {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &-text {
        font-size: 14px;
        font-weight: 500;
        text-align: center;
      }

      &-sub-text {
        font-size: 16px;
      }
    }

    &__table{
      .vs-table--tbody{
        border: none;
        background: #fff;
      }

      .vs-table--thead th{
        padding: 0!important;
        border-bottom: 1px solid rgba(0,0,0,.125);

        .vs-table-text{
          text-align: center;
          position: relative;
          vertical-align: bottom;
          padding: .75rem 10px;
          background: transparent;
          font-size: 12px;
          justify-content: center;
        }
      }

      .vs-table{
        .vs-table--tr:nth-child(2n+1){
          background: #f5f8fa;
        }
      }

      .tr-values td{
        padding: .5rem 10px;
        font-size: 12px;
        text-align: center;
      }

      .vs-table--pagination{
        justify-content: center;
      }
    }
  }

</style>